import React from 'react'
import PropTypes from 'prop-types'

import ImagePreview from 'components/FilePreview/ImagePreview'
import VideoPreview from 'components/FilePreview/VideoPreview'

import FullTextPreview from '../FullTextPreview'

import Styles from './index.scss'

const Portfolios = (props) => {
  let previews = (
    <ImagePreview reference={props.portfolio} className="img-responsive" maxWidth="100%" />
  )
  if (props.portfolio.filetype === 'video') {
    previews = (
      <div>
        <VideoPreview
          portfolio={{
            url: props.portfolio.url,
            urlRawFile: props.portfolio.urlRawFile,
          }}
          fullPage="fullPage"
        />
        <a href={props.portfolio.urlRawFile} className={`${Styles.fullpage} btn btn-default`} target="_blank" rel="noopener noreferrer" >Fullpage</a>
      </div>
    )
  } else if (props.portfolio.filetype === 'text') {
    previews = (<FullTextPreview
      portfolio={props.portfolio}
      renderTextLayer
      scale={1.618}
    />)
  }
  return (
    <div>{previews}</div>
  )
}

Portfolios.propTypes = {
  portfolio: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    filetype: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    urlRawFile: PropTypes.string,
  }).isRequired,
}

export default Portfolios
